<script>

  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      value:{
        type: String,
        required: true
      },
      domPurify:{
        type: Boolean,
        default: false,
      },
      nameClasses:{
        type: String,
        default: ''
      },
      valueClasses:{
        type: String,
        default: ''
      },
      isLast:{
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <li
    v-if="value && name"
    class="tw-flex tw-flex-col md:tw-flex-row"
    :class="{
      'tw-pb-2 md:tw-pb-3': !isLast,
    }">
    <span class="tw-text-black/75 tw-w-full md:tw-w-1/4" :class="nameClasses"><slot name="keyPrefix"/>{{name}}</span>
    <span class="tw-font-semibold md:tw-text-right md:tw-justify-end tw-w-full md:tw-w-3/4 tw-pl-12 md:tw-pl-0 tw-flex tw-pr-2.5 md:tw-pr-0" :class="valueClasses">
      <span v-if="domPurify" v-dompurify-html="value"/><template v-else>{{ value }}</template>
    </span>
  </li>
</template>
